module.exports = __webpack_public_path__ + "img/solution-dil-system-pic-2.852c8594.png";